function __initCreditUpsellModal() {
  if (window.__creditUpsellModalInitialized) return;
  window.__creditUpsellModalInitialized = true;

  const SESSION_KEY = 'credit-upsell-dismissed';

  function getModals() {
    return document.querySelectorAll('[data-credit-upsell-modal]');
  }

  function getModal(variant) {
    return document.querySelector(`[data-credit-upsell-modal="${variant}"]`);
  }

  function openModal(modal) {
    if (!modal) return;
    modal.classList.add('is-open');
    document.documentElement.classList.add('credit-upsell-open');
    document.body.classList.add('credit-upsell-open');
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('credit-upsell-open');
    document.body.classList.remove('credit-upsell-open');
  }

  function dismissModal(modal, saveSession = true) {
    if (saveSession) {
      try {
        sessionStorage.setItem(SESSION_KEY, '1');
      } catch (e) {}
    }
    closeModal(modal);
  }

  function parseCartParams(url) {
    const params = {};
    try {
      const urlObj = new URL(url, window.location.origin);
      params.id = urlObj.searchParams.get('id');
      params.quantity = parseInt(urlObj.searchParams.get('quantity')) || 1;
      params.selling_plan = urlObj.searchParams.get('selling_plan') || null;
    } catch (e) {}
    return params;
  }

  function getCart() {
    var timestamp = new Date().getTime();
    return fetch(window.Shopify.routes.root + 'cart.js?t=' + timestamp, {
      method: 'GET',
      credentials: 'include'
    }).then(function(response) {
      if (response.ok) {
        return response.json();
      }
      return null;
    }).catch(function() {
      return null;
    });
  }

  function isInCart(cart, variantId, sellingPlanId) {
    if (!cart || !cart.items || cart.items.length === 0) return false;
    var variantIdStr = String(variantId);

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (String(item.variant_id) === variantIdStr) {
        return true;
      }
    }
    return false;
  }

  function addToCart(cartParams) {
    const variantId = cartParams.id;
    const quantity = cartParams.quantity;
    const sellingPlanId = cartParams.selling_plan;
    const drawer = document.querySelector('m-cart-drawer');

    const formData = {
      items: [{
        id: variantId,
        quantity: quantity
      }]
    };

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      formData.sections = drawer.getSectionsToRender().map(function(section) {
        return section.id;
      });
      formData.sections_url = window.location.pathname;
    }

    if (sellingPlanId) {
      formData.items[0].selling_plan = sellingPlanId;
    }

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(function(response) {
      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }
      return response.json();
    });
  }

  function openCartDrawer(trigger, cartResponse) {
    const drawer = document.querySelector('m-cart-drawer');
    if (!drawer || !window.MinimogSettings || !MinimogSettings.enable_cart_drawer) return;

    if (cartResponse && cartResponse.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(cartResponse);
      return;
    }

    if (typeof drawer.onCartDrawerUpdate === 'function') {
      drawer.onCartDrawerUpdate();
    }

    if (typeof drawer.open === 'function') {
      drawer.open(trigger);
    } else if (window.MinimogEvents && window.MinimogTheme) {
      window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
    }
  }

  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-credit-upsell-trigger]');
    if (trigger) {
      e.preventDefault();
      if (trigger.classList.contains('loading')) return;

      const variant = trigger.dataset.creditUpsellTrigger;
      const cartUrl = trigger.getAttribute('href');

      if (cartUrl && cartUrl !== '/cart' && cartUrl !== '#') {
        const cartParams = parseCartParams(cartUrl);

        if (cartParams.id) {
          const originalText = trigger.textContent;
          const fallbackUrl = cartUrl;
          trigger.textContent = 'Adding...';
          trigger.classList.add('loading');

          getCart()
            .then(function(cart) {
              var alreadyInCart = isInCart(cart, cartParams.id, cartParams.selling_plan);
              if (alreadyInCart) {
                trigger.classList.remove('loading');
                trigger.textContent = originalText;
                var modal = getModal(variant);
                if (modal) {
                  openModal(modal);
                }
                return null;
              }
              return addToCart(cartParams);
            })
            .then(function(result) {
              if (result === null) return;
              trigger.classList.remove('loading');
              trigger.textContent = originalText;
              if (window.MinimogEvents && window.MinimogTheme) {
                window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, result);
              }
              openCartDrawer(trigger, result);
              var modal = getModal(variant);
              if (modal) {
                openModal(modal);
              }
            })
            .catch(function(err) {
              trigger.classList.remove('loading');
              trigger.textContent = originalText;
              window.location.href = fallbackUrl;
            });
          return;
        }
      }

      const modal = getModal(variant);
      openModal(modal);
      return;
    }

    const closeBtn = e.target.closest('[data-credit-upsell-close]');
    if (closeBtn) {
      const modal = closeBtn.closest('[data-credit-upsell-modal]');
      dismissModal(modal, false);
      return;
    }

    const declineBtn = e.target.closest('[data-credit-upsell-decline]');
    if (declineBtn) {
      e.preventDefault();
      const modal = declineBtn.closest('[data-credit-upsell-modal]');
      dismissModal(modal, true);
      window.location.href = '/cart';
      return;
    }
  });

  getModals().forEach(function(modal) {
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        dismissModal(modal, false);
      }
    });
  });
}

function init() {
  if (typeof __initCreditUpsellModal === 'function') {
    __initCreditUpsellModal();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
